import { DisablePaymentPlatforms, DisablePaymentPlatformsVersion } from 'types/disablePayment';

export const isEnum = <T extends DisablePaymentPlatforms | DisablePaymentPlatformsVersion>(
  value: any,
  enumObject: Record<string, T>
): value is T => Object.values(enumObject).includes(value);
